<div class="flex flex-row w-full align-items mt-1 mb-2 cursor-pointer">
    <div
        class="flex flex-col"
        [class]="columnWidthClasses.controlPoint">
        <p class="detail-header-text">
            {{ 'severity' | transloco }}
        </p>
        <span
            class="size-2 rounded-full ml-5 mt-1 outline outline-1 outline-black"
            [class]="severityColorClasses[controlResult().severity]"
            [matTooltip]="controlResult().severity | transloco">
        </span>
    </div>

    <div
        class="flex flex-col"
        [class]="columnWidthClasses.result">
        <p class="detail-header-text">
            {{ 'controlledAt' | transloco }}
        </p>

        <p class="content-p">
            @if (controlResult().controlledAt) {
                {{ controlResult().controlledAt! | translocoDate }}
            } @else {
                -
            }
        </p>
    </div>

    <div
        class="flex flex-col"
        [class]="columnWidthClasses.status">
        <p class="detail-header-text">
            {{ 'controlledBy' | transloco }}
        </p>

        <p class="content-p">
            {{ controlResult().controlledByName }}
            <span class="pb-3 text-custom-blue">*</span>
        </p>
    </div>
</div>
